export default __webpack_public_path__ + "static/media/0x172370d5cd63279efa6d502dab29171933a610af.efaffcba.webp";